module.exports = {
  siteTitle: "My Study Community", // <title>
  shortSiteTitle: "MySc", // <title> ending for posts and pages
  siteDescription: "Changing your Study World - Let's Study!",
  siteUrl: "https://my-study-community.web.app/",
  // pathPrefix: "",
  siteImage: "mysc.jpeg",
  siteLanguage: "en",

  /* author */
  authorName: "Nicholas Mendez",
  authorTwitterAccount: "snickdx",

  /* info */
  headerTitle: "My Study Community",
  headerSubTitle: "Changing your Study World - Let's Study!",

  /* manifest.json */
  manifestName: "My Study Community",
  manifestShortName: "MySc", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "#00A79D",
  manifestThemeColor: "#262262",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/greglobinski" },
    { name: "twitter", url: "https://twitter.com/greglobinski" },
    { name: "facebook", url: "http://facebook.com/greglobinski" }
  ]
};
